import type { TaskReporterLogLevelOptions } from './types/TaskReporterLogLevelOptions.js';

/**
 * Returns a configuration with all reporter visuals disabled.
 */
// Use Required in the object type to verify that any new properties are added.
export const noLoggingConfig: Required<TaskReporterLogLevelOptions> = {
  showCompleted: false,
  showConsoleDebug: false,
  showConsoleError: false,
  showConsoleInfo: false,
  showConsoleLog: false,
  showConsoleWarn: false,
  showErrors: false,
  showPending: false,
  showStarted: false,
  showProductInfo: false,
  showSummary: false,
  showTaskDetails: false,
  showTaskExtended: false,
  showHeapUsage: false,
};

/**
 * Returns a configuration with the basic visuals enabled, excluding debug
 */
export const defaultLoggingConfig: Required<TaskReporterLogLevelOptions> = {
  ...noLoggingConfig,
  showConsoleError: true,
  showConsoleLog: true,
  showConsoleWarn: true,
  showErrors: true,
  showPending: true,
  showProductInfo: true,
  showSummary: true,
};

/**
 * Returns a configuration with most reporter visuals enabled, other than extended/debug logging details.
 */
export const verboseLoggingConfig: Required<TaskReporterLogLevelOptions> = {
  ...defaultLoggingConfig,
  showCompleted: true,
  showStarted: true,
  showConsoleInfo: true,
  showTaskDetails: true,
  showHeapUsage: true,
};

/**
 * Returns a configuration with all reporter visuals enabled.
 */
export const debugLoggingConfig: Required<TaskReporterLogLevelOptions> = {
  ...verboseLoggingConfig,
  showConsoleDebug: true,
  showTaskExtended: true,
};
